import { memo, useCallback } from "react";
import { Box, Button } from "@mui/material";
import TableCellComponent from "components/table/TableCellComponent";
import { TUploadImageType, WheelBrandListItem } from "../types/wheel-brand";

interface ActionButtonsCellProps {
  item: WheelBrandListItem;
  handleSelectedWheel: (type: TUploadImageType, item: WheelBrandListItem) => void;
}

const buttonStyles = {
  border: "1px solid var(--gray-250)",
  backgroundColor: "var(--white)",
  color: "var(--gray-600)",
  fontSize: { xs: "16px", md: "18px", xl: "20px" },
  borderRadius: "10px",
  minWidth: { xs: 100, lg: 170 },
  maxHeight: 32,
  whiteSpace: "pre",
  boxShadow: "var(--shadow)",
} as const;

const ActionButtonsCell = memo<ActionButtonsCellProps>(({ item, handleSelectedWheel }) => {
  const handleDetailImageUpload = useCallback(
    (type: TUploadImageType) => {
      handleSelectedWheel(type, item);
    },
    [handleSelectedWheel, item],
  );

  return (
    <TableCellComponent sx={{ px: 0 }}>
      <Box sx={{ display: "flex", justifyContent: "center", gap: 1 }}>
        <Button
          variant="outlined"
          sx={buttonStyles}
          onClick={() => handleDetailImageUpload("main")}
        >
          代表画像アップ
        </Button>
        <Button
          variant="outlined"
          sx={buttonStyles}
          onClick={() => handleDetailImageUpload("detail")}
        >
          詳細画像アップ
        </Button>
      </Box>
    </TableCellComponent>
  );
});

ActionButtonsCell.displayName = "ActionButtonsCell";

export default ActionButtonsCell;
